import { useState, useEffect } from "react";
import { debounce } from "lodash";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  const isSmallView = width <= 600;
  const isMediumView = width > 600 && width <= 1200;
  const isLargeView = width > 1200;

  return {
    width,
    height,
    isSmallView,
    isMediumView,
    isLargeView,
    viewSize: isSmallView
      ? "small"
      : isMediumView
      ? "medium"
      : isLargeView
      ? "large"
      : null,
  };
}

export function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    const handleResize = debounce(
      () => {
        setWindowDimensions(getWindowDimensions());
      },
      500,
      {
        leading: true,
        maxWait: 500,
      }
    );

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}
